import "./index.scss";

const SIZES = {
	small: {box: 36, stroke: 3},
	medium: {box: 44, stroke: 4},
	large: {box: 96, stroke: 7},
};

// Fascia del voto in proporzione alla scala: da 7 su 10 buono, da 6 sufficiente
export const scoreTone = (value, max = 10) => {
	if (value === null || value === undefined || isNaN(value)) return "empty";
	const ratio = value / max;
	if (ratio >= 0.7) return "good";
	if (ratio >= 0.6) return "fair";
	return "low";
};

const formatScore = (value, decimals) =>
	Number(value).toFixed(decimals).replace(".", ",");

// Anello del voto: arco proporzionale al voto, colore della fascia solo sull'arco.
// size: small 36 (card, con label sotto) | medium 44 (righe) | large 96 (schede)
export default function ScoreRing({
	value,
	max = 10,
	size = "medium",
	label,
	decimals = 1,
}) {
	const empty = value === null || value === undefined || isNaN(value);
	const {box, stroke} = SIZES[size] || SIZES.medium;
	const radius = (box - stroke) / 2;
	const circumference = 2 * Math.PI * radius;
	const ratio = empty ? 0 : Math.max(0, Math.min(1, value / max));
	const text = empty ? "—" : formatScore(value, decimals);
	const description =
		(label || "Voto") + (empty ? ": nessun voto" : " " + text + " su " + max);

	return (
		<span className={"score-ring score-ring--" + size}>
			<span
				className={"score-ring__circle score-ring--" + scoreTone(value, max)}
				role="img"
				aria-label={description}
				title={description}
			>
				<svg
					width={box}
					height={box}
					viewBox={`0 0 ${box} ${box}`}
					aria-hidden="true"
				>
					<circle
						className="score-ring__track"
						cx={box / 2}
						cy={box / 2}
						r={radius}
						strokeWidth={stroke}
					/>
					{!empty && (
						<circle
							className="score-ring__arc"
							cx={box / 2}
							cy={box / 2}
							r={radius}
							strokeWidth={stroke}
							strokeDasharray={`${circumference * ratio} ${circumference}`}
							transform={`rotate(-90 ${box / 2} ${box / 2})`}
						/>
					)}
				</svg>
				<span className="score-ring__value">{text}</span>
			</span>
			{label && <span className="score-ring__label">{label}</span>}
		</span>
	);
}
